import { Injectable } from '@angular/core';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {Router} from '@angular/router';
import {Http, Response} from '@angular/http';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class BankService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  getAllBanks() {
    return this._http.get(constant.URL_BANKS, this.getHeader()).map(res => res.json());
  }

  getBank(bankId) {
    return this._http.get(constant.URL_BANKS + '/' + bankId, this.getHeader()).map(res => res.json());
  }

  storeBank(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_BANKS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  updateBank(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_BANKS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  deleteBank(data: any) {
    return this._http
      .delete(`${constant.URL_BANKS}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/administration/bank.service.ts